let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bGDi2")).then(() => parcelRequire('grMo4'));